<template>
  <div class="flex flex-1 flex-grow flex-col justify-between pb-4">
    <div
      class="flex flex-1 flex-col items-center justify-center space-y-4 text-center"
    >
      <div class="space-y-1">
        <h3 class="text-text-neutral-primary text-lg font-semibold">
          {{ $t('ancillaries.seatMap.error.title') }}
        </h3>
        <p class="text-text-neutral-secondary text-sm">
          {{ $t('ancillaries.seatMap.error.message') }}
        </p>
      </div>
      <FreeButton
        type="button"
        class="gray-button w-full"
        @click="emit('onRefetch')"
      >
        {{ $t('ancillaries.seatMap.error.action') }}
      </FreeButton>
    </div>
    <slot></slot>
  </div>
</template>

<script setup lang="ts">
  import { FreeButton } from 'freedom-shared';

  const emit = defineEmits<{
    onRefetch: [];
  }>();
</script>
